import {Route, Routes} from 'react-router-dom'

import {CompanyLogin} from './components/CompanyLogin'
import {CompanyLoginOTP} from './components/CompanyLoginOTP'

import {CompanyOnboard} from './components/CompanyOnboard'
import {CompanyOnboardOTP} from './components/CompanyOnboardOTP'

import {CompanyForgotPassword} from './components/CompanyForgotPassword'
import {CompanyForgotPasswordOTP} from './components/CompanyForgotPasswordOTP'

import {CompanyAuthLayout} from './CompanyAuthLayout'


const CompanyAuthPage = () => (
    <Routes>
        <Route element={<CompanyAuthLayout />}>
            <Route path='login' element={<CompanyLogin />} />
            <Route path='otp' element={<CompanyLoginOTP />} />

            <Route path='createaccount' element={<CompanyOnboard />} />            
            <Route path='accountotp' element={<CompanyOnboardOTP />} />

            <Route path='forgot-password' element={<CompanyForgotPassword />} />
            <Route path='forgot-password-otp' element={<CompanyForgotPasswordOTP />} />
            
            <Route index element={<CompanyLogin />} />
        </Route>
    </Routes>
)

export {CompanyAuthPage}
